import { BoundaryCreateWMSOptimizedStatusResponse } from '~/map/map.repository';
import { BoundaryCreateWMSOptimizedStatus } from './boundaryCreateWMSOptimized.state';

export const createBoundaryCreateWMSOptimizedStatusFromResponse = (
  responseStatus: BoundaryCreateWMSOptimizedStatusResponse
): BoundaryCreateWMSOptimizedStatus => {
  switch (responseStatus) {
    case BoundaryCreateWMSOptimizedStatusResponse.RequestAccepted:
      return BoundaryCreateWMSOptimizedStatus.ProcessingStarted;
    case BoundaryCreateWMSOptimizedStatusResponse.ValidatingRequest:
      return BoundaryCreateWMSOptimizedStatus.ValidatingRequest;
    case BoundaryCreateWMSOptimizedStatusResponse.StartingTerritories:
      return BoundaryCreateWMSOptimizedStatus.InitializingTerritories;
    case BoundaryCreateWMSOptimizedStatusResponse.BalancingTerritoriesAttempt1:
      return BoundaryCreateWMSOptimizedStatus.BalancingTerritories;
    case BoundaryCreateWMSOptimizedStatusResponse.BalancingTerritoriesAttempt2:
      return BoundaryCreateWMSOptimizedStatus.RebalancingTerritories;
    case BoundaryCreateWMSOptimizedStatusResponse.BalancingTerritoriesAttempt3:
      return BoundaryCreateWMSOptimizedStatus.FinalizingTheBalancingOfTerritories;
    case BoundaryCreateWMSOptimizedStatusResponse.ProcessingDone:
      return BoundaryCreateWMSOptimizedStatus.ProcessingFinished;
    case BoundaryCreateWMSOptimizedStatusResponse.CalculatingStatistics:
      return BoundaryCreateWMSOptimizedStatus.CalculatingStatistics;
    case BoundaryCreateWMSOptimizedStatusResponse.Finished:
      return BoundaryCreateWMSOptimizedStatus.Finished;
    default:
      return BoundaryCreateWMSOptimizedStatus.ProcessingStarted;
  }
};
